import { root, id } from './user-plans';

export const userPlans = {
  ...root,
  id,
};
